import React from "react";
// import "../assets/css/ErrorBoundary/ErrorBoundary.css";

/**
 * @param {Element} fallbackElement A passed element that contains an error message
 * @param {String} fallback A passed string that contains an error message
 * 
 * ## Fallback Element
 * - If this is included, fallback will be ignored
 * - ex.) ``` <div className="somepage-errorBoundary-container">I am a fallback error message for a page.</div> ```
 * 
 * ## Fallback
 * - is returned as a simple string
 */
class ErrorBoundary extends React.Component {
    state = {hasError: false}

    static getDerivedStateFromError(error) {
        return{hasError:true}
    }

    componentDidCatch(error, info) {
        console.log(error, info);
    }

    render() {
        if(this.state.hasError){
            if(this.props?.fallbackElement){
                return this.props.fallbackElement;
            }
            return this.props.fallback
        }

        return this.props.children
    }
};

export default ErrorBoundary;